// src/pages/Dashboard.tsx
// import React from "react";
import Navbar from "../components/navbar";
import dataVideo from "../assets/DataAnalytics.mp4";
import Stats from "../components/Stats";
import Partners from "components/Partners";
import ValueProposition from "components/ValueProposition";
import IndustryExpertise from "components/IndustryExpertise";
import Footer from "components/Footer";
import IntelligentSolutions from "components/IntelligentSolutions";
import { useEffect, useState } from "react";
import ContactModal from "components/ContactModal";
import SapDatabricksSection from "components/SapDatabricksSection";
import CaseStudies from "components/CaseStudies";

const Dashboard = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false); // ✅ modal state


  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest("nav")) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <>
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      {/* Hero Video Section */}
      <div className="relative">
        <video
          className="w-full h-48 sm:h-64 md:h-80 lg:h-[563px] object-cover"
          src="https://static.senpiper.com/bc410fe6-eb0b-4275-b3e7-de00b42592bc/65df2e5d-1579-45f6-b199-dbaeb5522a1b.mp4"
          autoPlay
          muted
          loop
          playsInline
        >
          Your browser does not support the video tag.
        </video>
        
        {/* Video Overlay Text */}
        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <div className="text-center text-white px-4 sm:px-6 lg:px-10">
            <h3 className="sm:text-4xl md:text-4xl lg:text-4xl font-['IBM Plex Sans'] font-bold mb-4 sm:mb-6 leading-tight">
              Transform your Enterprise with <br className="hidden sm:block" />
              <span className="text-blue-400">Data Analytics Excellence</span>
            </h3>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl max-w-2xl mx-auto leading-relaxed font-['Nunito Sans']">
              Harness the power of advanced data analytics and AI-driven insights to propel your business forward and redefine operational performance
            </p>
            <button
            onClick={() => setIsContactOpen(true)}
            data-button-state="Default"
            data-button-type="Primary"
            className="mt-2 sm:mt-4 lg:mt-9 
                      px-3 py-2 sm:px-5 sm:py-2.5 lg:px-7 lg:py-3 
                      bg-white rounded-lg inline-flex justify-center items-center 
                      shadow-sm hover:shadow-md hover:bg-slate-100 transition"
          >
            <span
              className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl 
                        text-blue-900 font-semibold font-nunito 
                        leading-snug tracking-tight"
            >
              Learn More
            </span>
          </button>

          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="p-4 sm:p-6 md:p-8 bg-slate-50">
        <Stats />
      </div>

      {/* Partners Section */}
      <Partners />

      {/* Value Proposition Section */}
      <ValueProposition />

      {/* Sap Databricks Section */}
      <SapDatabricksSection />

      {/* Industry Expertise Section */}
      <IndustryExpertise />

      {/* Intelligent Solutions Section */}
      <IntelligentSolutions/>
      <CaseStudies/>

      {/* <CaseStudyDetail/> */}

      {/* Contact CTA Section */}
      <div className="w-full px-4 sm:px-6 md:px-16 lg:px-36 py-12 sm:py-16 lg:py-20 bg-slate-50 flex flex-col items-center gap-8 sm:gap-12">
        <div className="max-w-4xl text-center flex flex-col gap-4 sm:gap-6 px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-zinc-700 tracking-wide font-['IBM_Plex_Sans'] leading-tight">
            Get in Touch with Senpiper
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 font-['Nunito Sans'] leading-relaxed">
            Connect with our data analytics experts to explore solutions, request demos, or discuss your project needs
          </p>
        </div>
        <button
          type="button"
          className="px-6 sm:px-8 py-3 sm:py-4 bg-blue-900 rounded-md text-white text-base sm:text-lg font-semibold font-['Open Sans'] hover:bg-blue-800 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          onClick={() => setIsContactOpen(true)}
        >
          Connect Us
        </button>
      </div>

      <Footer />
    </div>   
    {/*  Contact Modal with required props */}
      <ContactModal
        open={isContactOpen}
        onClose={() => setIsContactOpen(false)}
        onSave={(contact) => {
          console.log("Contact saved:", contact);
          // setIsContactOpen(false);
        }}
      />
    </>
  );
};

export default Dashboard;
